import React from 'react';
import classNames from 'classnames';
import { MultiOption } from 'components/MultiSelect/MultiSelect.component';
import { Button } from 'ncoded-component-library';
import XIcon from 'icons/X.icon';

import './SelectionItem.styles.scss';

type SelectionItemProps<T> = {
  className?: string;
  onDelete: (value: T) => void;
} & MultiOption<T>;

function SelectionItem<T extends Record<string, any>>(
  props: SelectionItemProps<T>,
) {
  const { className, label, value, onDelete } = props;

  const classes = classNames('ncoded-selection-item', className);

  return (
    <div className={classes}>
      <p className="ncoded-selection-item__title">{label}</p>
      <Button
        className="xmark"
        aria-label="Remove"
        variant="link"
        icon={XIcon}
        onClick={(e) => {
          e.stopPropagation();
          onDelete(value);
        }}
      />
    </div>
  );
}

export default SelectionItem as <
  T extends Record<string, any> | string | number,
>(
  props: SelectionItemProps<T>,
) => React.ReactElement;
